module.exports = __webpack_public_path__ + "img/sixpackcarrier38.5fd0e192.jpg";